/**
 * Frequently Asked Questions body rendered inside the Settings
 * FullScreenSheet. Questions mirror the onboarding troubleshooting copy
 * so users who hit the same friction post-onboarding can find answers
 * in the same words — plus a couple of product-level questions (AI
 * reliability, data privacy) the support team has been asked in beta.
 */
const ITEMS = [
  {
    question: 'How does Yaruta know which emails to read?',
    answer:
      'Yaruta only reads emails as they arrive, from senders you approve or domains you add to your school/sports list. We never scan your past emails.',
  },
  {
    question: "I'm not sure if Gmail forwarding worked",
    answer:
      "Tap 'I've set this up' in the app — we check the connection automatically. If something's off, we'll let you know what to fix.",
  },
  {
    question: "I don't see the Forwarding option in Gmail",
    answer:
      "You're in the right place in Gmail, but this option may be hidden. If your Gmail is managed by a school or employer, ask your IT department to turn on forwarding for your account.",
  },
  {
    question: 'Google is asking me to verify on my phone or email',
    answer:
      "That's normal — Google chooses the verification method based on your account. Follow the prompt on your phone or check your email, then come back to the app and tap 'I've set this up.'",
  },
  {
    question: 'Are the AI-extracted tasks and events always correct?',
    answer:
      'They’re recommendations only. Parents always review and approve items before they land on the household schedule — AI suggests, parents approve.',
  },
  {
    question: 'Can I delete my data?',
    answer:
      'Yes. Email privacy@yaruta.app and we’ll remove your account and connected communications from our active systems. You can also delete your account from Settings.',
  },
];

export function FaqBody() {
  return (
    <div className="flex flex-col gap-5 text-base leading-6 text-foreground">
      {ITEMS.map((item) => (
        <div
          key={item.question}
          className="flex flex-col gap-1"
        >
          <h3 className="text-base font-semibold text-foreground leading-6">
            {item.question}
          </h3>
          <p className="text-sm text-muted-foreground leading-5">
            {item.answer}
          </p>
        </div>
      ))}
    </div>
  );
}
